export default __webpack_public_path__ + "static/media/pi-2.3cf6bf6b.jpg";